import React, { useCallback } from "react";
import styles from "../../styles/pages/user/content-buyer-notification.module.scss";
import {
  Box,
  Button,
  InputAdornment,
  List,
  ListItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
// import Image from "next/image";
import assest from "../../json/assest";
import { Link } from "react-router-dom";
import SelectMonth from "../SelectMonth/SelectMonth";
import SelectDay from "../SelectDay/SelectDay";
import SelectYear from "../SelectYear/SelectYear";
// import { useRouter } from "next/router";
import TableFilterIcon from "../../ui/Icons/TableFilterIcon";
import { NotificationFilterDates } from "../../data/consts";

const ContentbuyerNotificationFilter = (props) => {
  const [searchValue, setSearchValue] = React.useState("");
  const [currentDateFilter, setCurrentDateFilter] = React.useState("today");
  const [startDate, setStartDate] = React.useState({
    day: "",
    month: "",
    year: "",
  });
  const [startDate2, setStartDate2] = React.useState({
    day: "",
    month: "",
    year: "",
  });

  const [openFilterModal, setOpenFilterModal] = React.useState(false);

  const handleOpenFilterModal = useCallback(() => {
    setOpenFilterModal(true);
  }, []);

  const handleCloseFilterModal = useCallback(() => {
    setOpenFilterModal(false);
  }, []);

  const [messageby, setMessageby] = React.useState("");

  const handleChange1 = (event) => {
    setMessageby(event.target.value);
  };

  const [messageto, setMessageto] = React.useState("");

  const handleChange2 = (event) => {
    setMessageto(event.target.value);
  };

  const [noteby, setNoteby] = React.useState("");

  const handleChange3 = (event) => {
    setNoteby(event.target.value);
  };

  const [noteto, setNoteto] = React.useState("");

  const handleChange4 = (event) => {
    setNoteto(event.target.value);
  };

  // const router = useRouter();
  const handleChildData = (anchorEl) => {
    if (anchorEl.day) {
      setStartDate({ ...startDate, day: anchorEl.day });
    } else if (anchorEl.month) {
      setStartDate({ ...startDate, month: anchorEl.month });
    } else if (anchorEl.year) {
      setStartDate({ ...startDate, year: anchorEl.year });
    }
    console.warn("Received data from child:", anchorEl);
    console.warn(startDate);
  };

  const handleChildData2 = (anchorEl) => {
    if (anchorEl.day) {
      setStartDate2({ ...startDate2, day: anchorEl.day });
    } else if (anchorEl.month) {
      setStartDate2({ ...startDate2, month: anchorEl.month });
    } else if (anchorEl.year) {
      setStartDate2({ ...startDate2, year: anchorEl.year });
    }
    console.warn("Received data from child2:", anchorEl);
    console.warn(startDate2);
  };

  const filtereditorList2 = (type, day) => {
    // let date = new Date(2020, 4, 12);
    const date = new Date();
    let dd = date.getDate();
    let mm = date.getMonth();
    let yy = date.getFullYear();
    console.warn(date);
    let getThisWeek = new Date();
    function getMonday(d) {
      // let date = new Date(d);
      // console.warn(date)
      // console.warn(d)
      var day = d.getDay();
      var diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
      getThisWeek = new Date(d.setDate(diff));
    }

    if (day == "today") {
      let currentDate = Number(dd) > 9 ? Number(dd) : "0" + Number(dd);
      let currentMonth =
        Number(mm) > 9 ? Number(mm) + 1 : "0" + (Number(mm) + 1);
      let currentYear = Number(yy);
      let published_at_from =
        currentYear + "-" + currentMonth + "-" + currentDate;
      let published_at_to =
        currentYear + "-" + currentMonth + "-" + currentDate;
      props.getDataFromChild({
        startDate: published_at_from,
        endDate: published_at_to,
        type: day,
      });
    } else if (day == "yesterday") {
      let datex = date;
      datex.setDate(dd - 1);
      // console.warn(datex)
      let currentDate =
        datex.getDate() > 9 ? datex.getDate() : "0" + datex.getDate();
      let currentMonth =
        datex.getMonth() > 9
          ? datex.getMonth() + 1
          : "0" + (datex.getMonth() + 1);
      let currentYear = datex.getFullYear();
      let published_at_from =
        currentYear + "-" + currentMonth + "-" + currentDate;
      let published_at_to =
        currentYear + "-" + currentMonth + "-" + currentDate;
      props.getDataFromChild({
        startDate: published_at_from,
        endDate: published_at_to,
        type: day,
      });
    } else if (day == "this_week") {
      getMonday(date);
      // console.warn(getThisWeek)
      let currentDate = Number(dd) > 9 ? Number(dd) : "0" + Number(dd);
      let currentMonth = mm > 9 ? mm : "0" + (mm + 1);
      let currentYear = Number(yy);
      let currentDate2 =
        getThisWeek.getDate() > 9
          ? getThisWeek.getDate()
          : "0" + getThisWeek.getDate();
      let currentMonth2 =
        getThisWeek.getMonth() > 9
          ? getThisWeek.getMonth() + 1
          : "0" + (getThisWeek.getMonth() + 1);
      let currentYear2 = getThisWeek.getFullYear();
      let published_at_from =
        currentYear2 + "-" + currentMonth2 + "-" + currentDate2;
      let published_at_to =
        currentYear + "-" + currentMonth + "-" + currentDate;
      props.getDataFromChild({
        startDate: published_at_from,
        endDate: published_at_to,
        type: day,
      });
    } else if (day == "last_7_days") {
      let currentDate = Number(dd) > 9 ? Number(dd) : "0" + Number(dd);
      let currentMonth =
        Number(mm) > 9 ? Number(mm) + 1 : "0" + (Number(mm) + 1);
      let currentYear = Number(yy);
      let datex = date;
      datex.setDate(date.getDate() - 7);
      // console.warn(datex)
      let currentDate2 =
        datex.getDate() > 9 ? datex.getDate() : "0" + datex.getDate();
      let currentMonth2 =
        datex.getMonth() + 1 > 9
          ? datex.getMonth() + 1
          : "0" + (datex.getMonth() + 1);
      let currentYear2 = datex.getFullYear();
      let published_at_from =
        currentYear2 + "-" + currentMonth2 + "-" + currentDate2;
      let published_at_to =
        currentYear + "-" + currentMonth + "-" + currentDate;
      props.getDataFromChild({
        startDate: published_at_from,
        endDate: published_at_to,
        type: day,
      });
    } else if (day == "this_month") {
      let currentDate = Number(dd) > 9 ? Number(dd) : "0" + Number(dd);
      let currentMonth =
        Number(mm) > 9 ? Number(mm) + 1 : "0" + (Number(mm) + 1);
      let currentYear = Number(yy);
      let currentDate2 = "0" + (Number(dd) - Number(dd) + 1);
      let currentMonth2 =
        Number(mm) > 9 ? Number(mm) + 1 : "0" + (Number(mm) + 1);
      let currentYear2 = Number(yy);
      let published_at_from =
        currentYear2 + "-" + currentMonth2 + "-" + currentDate2;
      let published_at_to =
        currentYear + "-" + currentMonth + "-" + currentDate;
      props.getDataFromChild({
        startDate: published_at_from,
        endDate: published_at_to,
        type: day,
      });
    } else if (day == "last_month") {
      let datex = date;
      datex.setDate(date.getDate() - dd);
      // console.warn(datex)
      let days = datex.getDate() + 1;
      console.warn("0" + (datex.getDate() - datex.getDate() + 1));
      let currentDate = datex.getDate();
      let currentMonth =
        datex.getMonth() + 1 > 9
          ? datex.getMonth() + 1
          : "0" + (datex.getMonth() + 1);
      let currentYear = datex.getFullYear();
      let currentDate2 = "0" + (datex.getDate() - datex.getDate() + 1);
      let currentMonth2 =
        datex.getMonth() + 1 > 9
          ? datex.getMonth() + 1
          : "0" + (datex.getMonth() + 1);
      let currentYear2 = datex.getFullYear();
      let published_at_from =
        currentYear2 + "-" + currentMonth2 + "-" + currentDate2;
      let published_at_to =
        currentYear + "-" + currentMonth + "-" + currentDate;
      props.getDataFromChild({
        startDate: published_at_from,
        endDate: published_at_to,
        type: day,
      });
    } else if (day == "last_6_months") {
      let datex = date;
      datex.setMonth(date.getMonth() - 5);
      // console.warn(datex)
      let days = datex.getDate();
      let currentDate = dd > 9 ? dd : "0" + dd;
      let currentMonth = mm + 1 > 9 ? mm + 1 : "0" + (mm + 1);
      let currentYear = yy;
      let currentDate2 = "0" + (days - days + 1);
      let currentMonth2 =
        datex.getMonth() + 1 > 9
          ? datex.getMonth() + 1
          : "0" + (datex.getMonth() + 1);
      let currentYear2 = datex.getFullYear();
      let published_at_from =
        currentYear2 + "-" + currentMonth2 + "-" + currentDate2;
      let published_at_to =
        currentYear + "-" + currentMonth + "-" + currentDate;
      props.getDataFromChild({
        startDate: published_at_from,
        endDate: published_at_to,
        type: day,
      });
    } else if (day == "this_year") {
      let currentDate = Number(dd) > 9 ? Number(dd) : "0" + Number(dd);
      let currentMonth =
        Number(mm) > 9 ? Number(mm) + 1 : "0" + (Number(mm) + 1);
      let currentYear = Number(yy);
      let currentDate2 = "0" + (Number(dd) - Number(dd) + 1);
      let currentMonth2 = "0" + (Number(mm) - Number(mm) + 1);
      let currentYear2 = Number(yy);
      let published_at_from =
        currentYear2 + "-" + currentMonth2 + "-" + currentDate2;
      let published_at_to =
        currentYear + "-" + currentMonth + "-" + currentDate;
      props.getDataFromChild({
        startDate: published_at_from,
        endDate: published_at_to,
        type: day,
      });
    } else if (day == "last_year") {
      let datex = date;
      datex.setFullYear(yy - 1);
      // console.warn(datex)
      let currentDate = 31;
      let currentMonth = datex.getMonth() * 0 + 12;
      let currentYear = datex.getFullYear();
      let currentDate2 = "0" + (datex.getDate() - datex.getDate() + 1);
      let currentMonth2 = "0" + (datex.getMonth() - datex.getMonth() + 1);
      let currentYear2 = datex.getFullYear();
      let published_at_from =
        currentYear2 + "-" + currentMonth2 + "-" + currentDate2;
      let published_at_to =
        currentYear + "-" + currentMonth + "-" + currentDate;
      props.getDataFromChild({
        startDate: published_at_from,
        endDate: published_at_to,
        type: day,
      });
    }
    setCurrentDateFilter(day);
  };
  let tarikh = startDate.year + "-" + startDate.month + "-" + startDate.day;
  let tarikh2 = startDate2.year + "-" + startDate2.month + "-" + startDate2.day;

  return (
    <>
      <Box className={styles.filterNotification}>
        {props?.filterType === "notification" ? (
          <Stack
            direction="row"
            alignItems="center"
            flexWrap="wrap"
            justifyContent="space-between"
            className={styles.filterHeading}
          >
            {/* <Button
                            className={styles.btnFilter}
                            onClick={() => handleOpenFilterModal()}
                        >
                            <TableFilterIcon />
                        </Button> */}
            <TextField
              id="outlined-size-normal"
              placeholder="Search..."
              InputProps={{
                startAdornment: (
                  <InputAdornment
                    position="start"
                    className={searchValue ? styles.startAdmnt : undefined}
                  >
                    <img
                      src={assest.icongraySearch}
                      width={11.5}
                      height={11.5}
                      alt="icon"
                    />
                  </InputAdornment>
                ),
              }}
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e.target.value);
                props.getDataFromChild(e.target.value);
              }}
              sx={
                searchValue
                  ? {
                      border: "1px solid #111AE9 !important",
                      borderRadius: "47px",
                    }
                  : undefined
              }
            />
          </Stack>
        ) : null}
        <List
          className={
            props?.filterType === "notification"
              ? `${styles.selectMonthList}`
              : `${styles.editorPad} ${styles.selectMonthList} commonLeftFilter`
          }
        >
          {NotificationFilterDates.map((item, index) => (
            <ListItem
              key={index}
              className={
                item.value === currentDateFilter
                  ? ""
                  : `${styles.forEditorToday}`
              }
            >
              <Link
                href="javascript:void(0)"
                onClick={() => filtereditorList2("filter", item.value)}
              >
                {item.name}
              </Link>
              {item.value === currentDateFilter ? (
                <Button onClick={() => filtereditorList2("filter", "today")}>
                  <img
                    src={assest.icongrayCross}
                    width={10}
                    height={10}
                    alt="icon"
                  />
                  view all
                </Button>
              ) : (
                ""
              )}
            </ListItem>
          ))}
          {/* <ListItem>
                        <Link
                            href="javascript:void(0)"
                            onClick={() => filtereditorList2("filter", "yesterday")}
                        >
                            Yesterday
                        </Link>
                    </ListItem>
                    <ListItem>
                        <Link
                            href="javascript:void(0)"
                            onClick={() => filtereditorList2("filter", "this_week")}
                        >
                            This week
                        </Link>
                    </ListItem>
                    <ListItem>
                        <Link
                            href="javascript:void(0)"
                            onClick={() => filtereditorList2("filter", "last_7_days")}
                        >
                            Last 7 days
                        </Link>
                    </ListItem>
                    <ListItem>
                        <Link
                            href="javascript:void(0)"
                            onClick={() => filtereditorList2("filter", "this_month")}
                        >
                            This month
                        </Link>
                    </ListItem>
                    <ListItem>
                        <Link
                            href="javascript:void(0)"
                            onClick={() => filtereditorList2("filter", "last_month")}
                        >
                            Last month
                        </Link>
                    </ListItem>
                    <ListItem>
                        <Link
                            href="javascript:void(0)"
                            onClick={() => filtereditorList2("filter", "last_6_months")}
                        >
                            Last 6 months
                        </Link>
                    </ListItem>
                    <ListItem>
                        <Link
                            href="javascript:void(0)"
                            onClick={() => filtereditorList2("filter", "this_year")}
                        >
                            This year
                        </Link>
                    </ListItem>
                    <ListItem>
                        <Link
                            href="javascript:void(0)"
                            onClick={() => filtereditorList2("filter", "last_year")}
                        >
                            Last year
                        </Link>
                    </ListItem> */}
        </List>
        <Box className={`${styles.dateRange} commonDateRange`}>
          <Typography variant="overline">Start date</Typography>
          <Stack direction="row" flexWrap="wrap" className={styles.monthStacks}>
            <SelectMonth sendDataToParent={handleChildData} />
            <SelectDay sendDataToParent={handleChildData} />
            <SelectYear sendDataToParent={handleChildData} />
          </Stack>
        </Box>
        <Box className={`${styles.dateRange} commonDateRange`}>
          <Typography variant="overline">End date</Typography>
          <Stack direction="row" flexWrap="wrap" className={styles.monthStacks}>
            <SelectMonth sendDataToParent={handleChildData2} />
            <SelectDay sendDataToParent={handleChildData2} />
            <SelectYear sendDataToParent={handleChildData2} />
          </Stack>
        </Box>
        <Box className={`${styles.dateConfirm} commonDateConfirm`}>
          <Button
            onClick={() =>
              props.getDataFromChild({
                startDate: tarikh,
                endDate: tarikh2,
                type: "custom date",
              })
            }
          >
            <span>Confirm</span> date range
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default ContentbuyerNotificationFilter;
